import { atom } from "jotai";

interface State {
  hasTabNav?: boolean;
  fixedNav?: boolean;
}

export default atom<State>({});
